import React, { Component } from "react";
import PropTypes from "prop-types";
import "@nosferatu500/react-sortable-tree/style.css";
import SortableTree from "@nosferatu500/react-sortable-tree";

class CustomTree extends Component {
  static defaultProps = {
    treeData: [],
    generateNodeProps: (f) => f,
    treeLoading: false,
    onChange: () => {},
  };

  render() {
    if (this.props.treeLoading) return <p>Loading...</p>;

    return (
      <div style={{ height: 700 }}>
        <SortableTree
          canDrag={false}
          treeData={this.props.treeData}
          onChange={this.props.onChange}
          generateNodeProps={this.props.generateNodeProps}
          style={{ fontWeight: "lighter", font: "inherit" }}
        />
      </div>
    );
  }
}

CustomTree.propTypes = {
  treeData: PropTypes.array.isRequired,
  treeLoading: PropTypes.bool,
  generateNodeProps: PropTypes.func,
  onChange: PropTypes.func,
};

export default CustomTree;
